import { render, staticRenderFns } from "./InvestmentBanner.vue?vue&type=template&id=6bf2a53a&"
import script from "./InvestmentBanner.vue?vue&type=script&lang=js&"
export * from "./InvestmentBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports